import React, { useEffect, useRef, useState } from 'react'
import InsertEmoticonIcon from '@material-ui/icons/InsertEmoticon'
import EmojiPicker from 'emoji-picker-react'
import './Style/Components.scss'
import { toAbsoluteUrl, countWords } from '../../_metronic/helpers'
import { useDispatch, useSelector } from 'react-redux'
import { AnyAction } from 'redux'
import { last, uniq } from 'lodash'
import { ThunkDispatch } from 'redux-thunk'
import {
  getAllTemplateWithoutPagination,
  getTemplateListWithoutPagination,
} from '../pages/UserPages/MyTemplate/CreateScratch/CreateScratchSlices/CreateScratchSlices'
import { GetAllData } from '../pages/UserPages/reports-analytics/ShortLinkSlice/ShortLinkSlice'
import { GetData as GetSubscriberFieldData } from '../pages/UserPages/Contacts/AllContactsList/SubscriberSlice/SubscriberSlice'
import { confirm } from 'react-confirm-box'
import { AuthenticateUser } from '../Utils/_helpers/RoleAndPermission'
import Select from 'react-select'
import { DEFAULT_REPLY_STOP_OUT_COUNT, processData, replaceMessageWith } from '../Utils/_helpers'
import { ENV } from '../Utils/_helpers/EnvHelper'
import { BulkMsgDraftData } from '../pages/UserPages/new-message/BulkMessageSlice/BulkMessageSlice'
import { GLOBAL_SETTINGS_TYPE } from '../Utils/Constant/ConstantForWebsite'
import { base64ToBlob, blobToFile } from '../Utils/file'
import {
  getDefaultOptOutUrlCount,
  getDefaultShortUrl,
  getIsDefaultRegion,
} from '../pages/UserPages/accounts/Overview/OverviewSlice/UserDetailsSlice'
import { InputMessageContent } from './InputMessageContent'
import ShortUrlModal from '../pages/UserPages/MyTemplate/CreateScratch/ShortUrlModal'
import UnicodeModal from './UnicodeModal'
import { InputMessageContentRef } from './types/InputMessageContent'
import { OverlayTrigger, Tooltip } from 'react-bootstrap'

const MessageBoxV2 = ({
  setUserMessage,
  userMessage,
  selectedFile,
  itQuickMessage,
  quickSms,
  disableTextfield,
  setError,
  error,
  isInbox,
  isTemplate,
  showSelect,
  isRMSChat = false,
  onlyStop = false,
  isAlphaId = false,
  isDraft = false,
  containerStyle = {},
  setIsForward,
  isMobile = false,
  enableUnicodeModal = false,
}: any) => {
  const dispatch = useDispatch()
  const thunkDispatch = useDispatch<ThunkDispatch<any, any, AnyAction>>()

  const inputRef = useRef<InputMessageContentRef | null>(null) // Updated ref type
  const pickerRef: any = useRef(null)
  const [popup, setPopup] = useState(false)
  const [showUnicodeModal, setShowUnicodeModal] = useState(false)
  const CustomFieldName: any = useSelector(
    (state: any) => state?.subscriberData?.FieldName?.data?.fields
  )
  const customFieldLoading: boolean = useSelector(
    (state: any) => state?.subscriberData?.FieldNameLoading
  )
  const isDefaultRegion = useSelector(getIsDefaultRegion)
  const defaultDomain = useSelector(getDefaultShortUrl)
  const defaultOptOutUrlCount = useSelector(getDefaultOptOutUrlCount)

  useEffect(() => {
    thunkDispatch(GetAllData({}))
    thunkDispatch(GetSubscriberFieldData())
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const conditionData =
    userMessage?.senderType == 'businessName' || userMessage?.senderType == 'customNumber'

  const userGlobalSettings = useSelector(
    (state: any) => state?.userDetails?.userDetails?.data?.user?.globalSetting
  )

  let optoutList = useSelector((state: any) => {
    // const userGlobalSettings = state?.userDetails?.userDetails?.data?.user?.globalSetting
    let list = state?.optoutList?.optoutList?.data?.items || []

    if (quickSms) {
      const isDisableReplyByGlobalOption = userGlobalSettings?.includes(
        itQuickMessage
          ? GLOBAL_SETTINGS_TYPE.QUICK_SMS_REPLY_STOP_OUTPUT
          : GLOBAL_SETTINGS_TYPE.BULK_SMS_REPLY_STOP_OUTPUT
      )

      list = isDisableReplyByGlobalOption ? list : []
    }

    if (!quickSms) {
      const isDisableReplyByGlobalOption = userGlobalSettings?.includes(
        itQuickMessage
          ? GLOBAL_SETTINGS_TYPE.QUICK_MMS_REPLY_STOP_OUTPUT
          : GLOBAL_SETTINGS_TYPE.BULK_MMS_REPLY_STOP_OUTPUT
      )
      list = isDisableReplyByGlobalOption ? list : []
    }

    if (onlyStop) {
      return []
    }

    return list
  })
  const LandingPageList = useSelector((state: any) => state?.LandingPage?.landingPage?.data)
  const ShortLinkList = useSelector((state: any) => state?.ShortLink?.allTrackingLinks)

  // const templates: any = useSelector(getTemplateList)
  const templates: any = useSelector(getTemplateListWithoutPagination)
  const [showPicker, setShowPicker] = useState(false)
  const [webLinkDataToEdit, setWebLinkDataToEdit] = useState({ longUrl: '', shortUrl: '' })

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [options, setOptions] = useState({
    webLink: [
      {
        value: 'create',
        label: 'Create..',
        // label: (
        //   <button
        //     disabled={userMessage?.longUrl?.length >= 4}
        //     onClick={(e: any) => {
        //       e.preventDefault()
        //       setPopup(true)
        //       setWebLinkDataToEdit({longUrl: '', shortUrl: ''})
        //     }}
        //   >
        //     Create New
        //   </button>
        // ),
      },
    ],

    optOut: [{ value: 'ReplyStop', label: `Reply 'Stop' to opt out`, isDisabled: conditionData }],
  })

  useEffect(() => {
    const handleOutsideClick = (e: any) => {
      if (pickerRef.current && !pickerRef.current.contains(e.target)) {
        setShowPicker(false)
      }
    }

    document.addEventListener('mousedown', handleOutsideClick)

    return () => {
      document.removeEventListener('mousedown', handleOutsideClick)
    }
  }, [])
  
  useEffect(() => {
    AuthenticateUser('templates-list') && dispatch(getAllTemplateWithoutPagination())
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  /**
   * 
   *   const optOut = [
        // {
        //   value: '',
        //   label: `${
        //     userMessage?.replyStopToOptOut ? " Reply 'Stop' to opt-out" : 'STOP:{stoptxt.cc/}'
        //   }`,
        //   isDisabled: false,
        // },
        // {value: 'ReplyStop', label: `Reply 'Stop' to opt out`, isDisabled: conditionData},
      ]
   */

  let data =
    CustomFieldName?.length > 0
      ? uniq(CustomFieldName as string[]) // Remove duplicates
        .map((key: string) => ({
          value: `{{[${key}]}}`,
          label: key,
        }))
      : [];
  const LandingPages =
    LandingPageList?.length > 0
      ? LandingPageList?.map((key: any) => {
        return {
          value: `${key?._id}`,
          label: `${key?.campaignName}`,
        }
      })
      : []

  const CustomOptOutList =
    optoutList?.length > 0
      ? optoutList?.map((key: any) => {
        return {
          value: `${key?._id}`,
          label: `${key?.title}`,
        }
      })
      : []

  const Templates =
    templates?.length > 0
      ? templates
        ?.filter((key: any) => (key?.type?.toUpperCase() === userMessage?.camp_type?.toUpperCase()) && (key?.category?.toUpperCase() === 'GENERAL' || !key?.category))
        ?.map((key: any) => {
          return {
            value: `${key?.name}`,
            label: `${key?.name}`,
          }
        })
      : []

  const ReviewTemplates =
    templates?.length > 0
      ? templates
        ?.filter((key: any) => key?.category?.toUpperCase() === 'REVIEW')
        ?.map((key: any) => {
          return {
            value: `${key?.name}`,
            label: `${key?.name}`,
          }
        })
      : []

  const handleChange = (e: any) => {
    if (e.label) {
      // Handle custom field insertion
      let errorData = { ...error }
      delete errorData.message
      setError(errorData)

      let startSubString = userMessage?.message?.slice(0, inputRef.current?.selectionStart)
      let endSubString = userMessage?.message?.slice(inputRef.current?.selectionEnd)
      let content = startSubString + e.value + ' ' + endSubString
      setUserMessage({ ...userMessage, message: content })

      if (isDraft) {
        dispatch(BulkMsgDraftData({ ...userMessage, scheduledAt: '', message: content }))
      }
      inputRef?.current?.focus()
    } else {
      // Handle regular text input
      let errorData = { ...error }
      delete errorData.message
      e.target.value !== ''
        ? setError(errorData)
        : setError({ ...error, message: 'Message is required' })

      setUserMessage({
        ...userMessage,
        [e.target.name]: e.target.value,
      })

      if (isDraft) {
        dispatch(
          BulkMsgDraftData({ ...userMessage, scheduledAt: '', [e.target.name]: e.target.value })
        )
      }
    }
  }

  const handleSelectShortUrl = (e: { label: string; shortUrl: string, upstreamUrl: string }) => {
    let startSubString = userMessage?.message?.slice(0, inputRef.current?.selectionStart)
    let endSubString = userMessage?.message?.slice(inputRef.current?.selectionEnd)

    if (e.shortUrl && e.upstreamUrl) {
      let errorData = { ...error }

      delete errorData.message
      setError(errorData)
      let previousMessage = userMessage?.message
      // eslint-disable-next-line no-useless-concat
      let addAgain = startSubString + `${defaultDomain}/${e.shortUrl}` + ' ' + endSubString
      const regex = /short\.cellcast\.com\/\w+/

      const finalLongUrl = {
        longUrl: e.upstreamUrl,
        shortUrl: e.shortUrl,
      }

      if (previousMessage?.match(regex) == null) {
        setUserMessage({
          ...userMessage,
          message: addAgain,
          longUrl: [...userMessage.longUrl, finalLongUrl],
        })
        if (isDraft) {
          dispatch(
            BulkMsgDraftData({
              ...userMessage,
              message: addAgain,
              longUrl: [...userMessage.longUrl, finalLongUrl],
            })
          )
        }
      } else {
        let content = previousMessage?.replace(
          new RegExp('\\b' + { defaultDomain } + '\\b'),
          e.shortUrl
        )
        setUserMessage({
          ...userMessage,
          message: content,
          longUrl: [...userMessage.longUrl, finalLongUrl],
        })
        if (isDraft) {
          dispatch(
            BulkMsgDraftData({
              ...userMessage,
              message: content,
              longUrl: [...userMessage.longUrl, finalLongUrl],
            })
          )
        }
      }
    }

    inputRef?.current?.focus()
  }

  const handleChangeLandingPage = (e: any) => {
    let startSubString = userMessage?.message?.slice(0, inputRef.current?.selectionStart || 0)
    let endSubString = userMessage?.message?.slice(inputRef.current?.selectionEnd || 0)

    if (e.value !== '') {
      // eslint-disable-next-line no-useless-concat
      let content = startSubString + `${ENV().REACT_APP_SHORTURL}/Lxxxxx` + ' ' + endSubString
      let errorData = { ...error }

      delete errorData.message
      setError(errorData)

      setUserMessage({ ...userMessage, message: content, landingPageId: e.value })
      if (isDraft) {
        dispatch(
          BulkMsgDraftData({
            ...userMessage,
            scheduledAt: '',
            message: content,
            landingPageId: e.value,
          })
        )
      }
      inputRef?.current?.focus()
    }
  }
  const handleWeblinkData = (e: any) => {
    if (e?.value === 'create') {
      setPopup(true)
      setWebLinkDataToEdit({ longUrl: '', shortUrl: '' })
    } else {
      // setPopup(true)
      // const webLinkData = userMessage?.longUrl ?? []
      // const findData = webLinkData.find((data: any) => data?.shortUrl == e?.value) ?? {
      //   longUrl: '',
      //   shortUrl: '',
      // }
      // setWebLinkDataToEdit({longUrl: findData?.longUrl, shortUrl: findData?.shortUrl})
      handleSelectShortUrl(e)
    }
  }

  const handleOptout = (e: any) => {
    if (e?.value !== '') {
      if (userMessage?.senderType === 'businessName' || userMessage?.senderType === 'customNumber') {
        if (e.value !== 'ReplyStop') {
          setUserMessage({
            ...userMessage,
            replyStopToOptOut: false,
            optout: true,
            optoutId: e.value,
            optoutLabel: e.label,
          })
        }

        if (isDraft) {
          dispatch(
            BulkMsgDraftData({
              ...userMessage,
              scheduledAt: '',
              replyStopToOptOut: false,
              optout: true,
              optoutId: e.value,
              optoutLabel: e.label,
            })
          )
        }
      } else {
        if (e.value == 'ReplyStop') {
          setUserMessage({ ...userMessage, replyStopToOptOut: true, optout: false, optoutId: '' })
          if (isDraft) {
            dispatch(
              BulkMsgDraftData({
                ...userMessage,
                scheduledAt: '',
                optoutId: '',
                replyStopToOptOut: true,
                optout: false,
              })
            )
          }
        } else {
          setUserMessage({
            ...userMessage,
            scheduledAt: '',
            replyStopToOptOut: false,
            optout: true,
            optoutId: e.value,
            optoutLabel: e.label,
          })

          if (isDraft) {
            dispatch(
              BulkMsgDraftData({
                ...userMessage,
                scheduledAt: '',
                replyStopToOptOut: false,
                optout: true,
                optoutId: e.value,
                optoutLabel: e.label,
              })
            )
          }
        }
      }
    } else {
      if (
        e.value === 'ReplyStop' &&
        userMessage?.senderType !== 'businessName' &&
        userMessage?.senderType !== 'customNumber'
      ) {
        setUserMessage({
          ...userMessage,
          replyStopToOptOut: true,
          optout: false,
          optoutId: '',
        })

        if (isDraft) {
          dispatch(
            BulkMsgDraftData({
              ...userMessage,
              scheduledAt: '',
              replyStopToOptOut: true,
              optout: false,
              optoutId: '',
            })
          )
        }
      } else {
        setUserMessage({
          ...userMessage,
          replyStopToOptOut: false,
          optout: true,
          optoutId: e.value,
          optoutLabel: e.label,
        })
        if (isDraft) {
          dispatch(
            BulkMsgDraftData({
              ...userMessage,
              scheduledAt: '',
              replyStopToOptOut: false,
              optout: true,
              optoutId: e.value,
              optoutLabel: e.label,
            })
          )
        }
      }
    }
  }

  const onEmojiClick = (event: any) => {
    let startSubString = userMessage?.message?.slice(0, inputRef.current?.selectionStart || 0)
    let endSubString = userMessage?.message?.slice(inputRef.current?.selectionEnd || 0)
    let content = startSubString + event.emoji + endSubString
    setUserMessage({ ...userMessage, message: content })

    if (isDraft) {
      dispatch(
        BulkMsgDraftData({
          ...userMessage,
          scheduledAt: '',
          message: content,
        })
      )
    }
    setShowPicker(false)
    inputRef?.current?.focus()
  }
  const optionsWithLabelChange: any = {
    closeOnOverlayClick: false,
    labels: {
      confirmable: 'Yes',
      cancellable: 'No',
    },
  }

  const handleTemplate = async (event: any) => {
    const confirmation = await confirm(
      `Are you sure you want to use this ${event?.value} template`,
      optionsWithLabelChange
    )
    if (confirmation) {
      if (event?.value !== '') {
        if (userMessage?.camp_type === 'sms') {
          /**
           * let startSubString = userMessage?.message?.slice(0, inputRef.current?.selectionStart || 0)
           * let endSubString = userMessage?.message?.slice(inputRef.current?.selectionEnd || 0)
           */
          let data = templates?.find((key: any) => key?.name === event?.value)
          if (data && data.longUrl && Array.isArray(data.longUrl)) {
            let longUrl = [...data.longUrl]
            let filteredLongUrl = longUrl.filter((item: any) => typeof item !== 'string')
            data = { ...data, longUrl: filteredLongUrl }
          }

          // replace all optout message
          const message = replaceMessageWith(data?.message, '')
          let newPayload = {
            ...userMessage,
            message,
            longUrl: data?.longUrl ?? undefined,
          }

          if (
            data?.optout &&
            data.optout === true &&
            data?.optoutId &&
            data.optoutId !== '' &&
            userGlobalSettings?.includes('bulkSMSReplyStopOutout')
          ) {
            const optOutData = optoutList.find((el: any) => el._id === data.optoutId)
            if (optOutData) {
              newPayload.optoutLabel = optOutData.title
            }

            newPayload.optout = data.optout
            newPayload.optoutId = data.optoutId
            newPayload.replyStopToOptOut = false
          } else {
            newPayload.optout = false
            newPayload.optoutId = ''

            if (optoutList.length > 0) {
              if (userGlobalSettings?.includes('bulkSMSReplyStopOutout')) {
                newPayload.replyStopToOptOut = true
              } else {
                newPayload.replyStopToOptOut = false
              }
            }
          }

          if (
            data?.landingPage &&
            data.landingPage === true &&
            data?.landingPageId &&
            data.landingPageId !== ''
          ) {
            newPayload.landingPage = data.landingPage
            newPayload.landingPageId = data.landingPageId
          }

          let errorData = { ...error }

          delete errorData.message
          newPayload.message !== ''
            ? setError(errorData)
            : setError({ ...error, message: 'Message is required' })

          if (data?.forwardReplyTo && data?.forwardReplyTo !== 'null' && setIsForward) {
            newPayload.forwardReplyTo = data.forwardReplyTo
            setIsForward(true)
          }

          setUserMessage(newPayload)
          if (isDraft) {
            dispatch(BulkMsgDraftData({ ...newPayload, scheduledAt: '' }))
          }
          inputRef?.current?.focus()
        } else {
          /**
           * let startSubString = userMessage?.message?.slice(0, inputRef.current?.selectionStart || 0)
           * let endSubString = userMessage?.message?.slice(inputRef.current?.selectionEnd || 0)
           */
          let messageData = replaceMessageWith(
            templates?.find((key: any) => key?.name === event?.value)?.message,
            ''
          )
          let data = templates?.find((key: any) => key?.name === event?.value)
          if (data && data.longUrl && Array.isArray(data.longUrl)) {
            let longUrl = [...data.longUrl]
            let filteredLongUrl = longUrl.filter((item: any) => typeof item !== 'string')
            data = { ...data, longUrl: filteredLongUrl }
          }

          if (data?.media !== '') {
            let newPayload = {
              ...userMessage,
              message: messageData,
              media: data?.media,
              gif: '',
              mediaType: data?.mediaType,
              urlData: {
                fileName: `${Date.now()}.jpg`,
                filetype: data?.mediaType,
                mediaType: data?.mediaType,
                url: data?.media,
              },
              subject: data?.subjectTitle,
              longUrl: data?.longUrl ?? undefined,
            }

            if (data?.base64media) {
              const fileName = data?.media.split('/').pop()
              const blob = base64ToBlob(data?.base64media, data?.mediaType)
              const file = blobToFile(blob, fileName)
              newPayload.media = file
            }

            if (
              data?.optout &&
              data.optout === true &&
              data?.optoutId &&
              data.optoutId !== '' &&
              userGlobalSettings?.includes('bulkMMSReplyStopOutout')
            ) {
              const optOutData = optoutList.find((el: any) => el._id === data.optoutId)
              if (optOutData) {
                newPayload.optoutLabel = optOutData.title
              }

              newPayload.optout = data.optout
              newPayload.optoutId = data.optoutId
              newPayload.replyStopToOptOut = false
            } else {
              newPayload.optout = false
              newPayload.optoutId = ''

              if (optoutList.length > 0) {
                if (userGlobalSettings?.includes('bulkMMSReplyStopOutout')) {
                  newPayload.replyStopToOptOut = true
                } else {
                  newPayload.replyStopToOptOut = false
                }
              }
            }

            if (
              data?.landingPage &&
              data.landingPage === true &&
              data?.landingPageId &&
              data.landingPageId !== ''
            ) {
              newPayload.landingPage = data.landingPage
              newPayload.landingPageId = data.landingPageId
            }

            let errorData = { ...error }

            delete errorData.message
            newPayload.message !== ''
              ? setError(errorData)
              : setError({ ...error, message: 'Message is required' })

            setUserMessage(newPayload)
            if (isDraft) {
              dispatch(BulkMsgDraftData({ ...newPayload, scheduledAt: '' }))
            }
          } else {
            let newPayload = {
              ...userMessage,
              message: messageData,
              gif: data?.gif,
              media: '',
              mediaType: data?.mediaType,
              subject: data?.subjectTitle,
              longUrl: data?.longUrl ?? undefined,
            }
            if (
              data?.optout &&
              data.optout === true &&
              data?.optoutId &&
              data.optoutId !== '' &&
              userGlobalSettings?.includes('bulkMMSReplyStopOutout')
            ) {
              const optOutData = optoutList.find((el: any) => el._id === data.optoutId)
              if (optOutData) {
                newPayload.optoutLabel = optOutData.title
              }

              newPayload.optout = data.optout
              newPayload.optoutId = data.optoutId
              newPayload.replyStopToOptOut = false
            } else {
              newPayload.optout = false
              newPayload.optoutId = ''
              if (optoutList.length > 0) {
                if (userGlobalSettings?.includes('bulkMMSReplyStopOutout')) {
                  newPayload.replyStopToOptOut = true
                } else {
                  newPayload.replyStopToOptOut = false
                }
              }
            }

            if (
              data?.landingPage &&
              data.landingPage === true &&
              data?.landingPageId &&
              data.landingPageId !== ''
            ) {
              newPayload.landingPage = data.landingPage
              newPayload.landingPageId = data.landingPageId
            }

            let errorData = { ...error }

            delete errorData.message
            newPayload.message !== ''
              ? setError(errorData)
              : setError({ ...error, message: 'Message is required' })


            setUserMessage(newPayload)
            if (isDraft) {
              dispatch(BulkMsgDraftData({ ...newPayload, scheduledAt: '' }))
            }
          }

          inputRef?.current?.focus()
        }
      }
    }
  }

  const containsEmoji = (str: string) => {
    const unicodeRegex = /[^\u0000-\u007F]/ // Matches non-ASCII characters (Unicode)
    const emojiRegex = /(\p{Emoji_Presentation}|\p{Emoji}\uFE0F|\p{Extended_Pictographic})/u // Matches emojis
    return unicodeRegex.test(str) || emojiRegex.test(str)
  }

  const optoutCount = userMessage?.optout === true ? defaultOptOutUrlCount : 0
  const replyStopToOptOutCount = userMessage?.replyStopToOptOut === true ? DEFAULT_REPLY_STOP_OUT_COUNT : 0
  /**
   * const webLinkOptions = userMessage?.longUrl
    ? userMessage?.longUrl?.map((key: any) => ({
      value: key?.shortUrl,
      label: key?.shortUrl,
    }))
    : []
   */


  const shortLinkOptions = ShortLinkList?.map((key: any) => ({
    shortUrl: key?.shortUrl,
    upstreamUrl: key?.upstreamUrl,
    label: `${last(key?.shortUrl.split('/'))} (${key?.upstreamUrl})`,
  }))

  let textMessage = userMessage?.message
  let shortUrlCount = 0

  if (userMessage?.longUrl?.length > 0) {
    const uniqueUrl = Array.from(new Map(userMessage.longUrl.map((item: any) => [item.shortUrl, item])).values())
    for (let index = 0; index < uniqueUrl.length; index++) {
      const element: any = uniqueUrl[index];
      let tempShortUrl = `${defaultDomain}/${element.shortUrl}`

      if (textMessage.split(tempShortUrl).length - 1) {
        shortUrlCount += (textMessage.split(tempShortUrl).length - 1) * 6
      }
    }
  }


  const extraMessageCount = replyStopToOptOutCount + optoutCount + shortUrlCount
  const messageCount = processData(textMessage ?? '', extraMessageCount, isAlphaId)

  return (
    <>
      <div style={{ ...containerStyle }}>
        <ShortUrlModal
          inputRef={inputRef}
          isShow={popup}
          initialData={webLinkDataToEdit}
          onClose={() => setPopup(false)}
          bulkMessageData={userMessage}
          setBulkMessageData={setUserMessage}
        />

        <UnicodeModal
          show={showUnicodeModal}
          onHide={() => setShowUnicodeModal(false)}
          message={textMessage}
        />
        <div>
          <div className='col-12 create-scratch-sms mb-7 message-wrapbox mt-0'>
            <div>
              <label className='custom-form-label' style={{ marginBottom: '8px' }}>
                {isMobile ? 'Write your message' : `Message Content ${userMessage?.abTest ? '(A)' : ''}`}
              </label>
              <OverlayTrigger
                placement='top'
                overlay={
                  <Tooltip id='button-tooltip'>
                    This is message content
                  </Tooltip>
                }
              >
                <i
                  data-bs-toggle='tooltip'
                  data-bs-placement='top'
                  className='bi bi-exclamation-circle-fill px-3'
                ></i>
              </OverlayTrigger>
            </div>
            <div className='d-flex row p-1 gx-0 gy-0 message-row px-6 py-0'>
              <div className='border-right-1 message-col'>
                <div className='selectbox' data-testid='ddCustomField'>
                  <img
                    className='imgpos'
                    src={toAbsoluteUrl('/media/mobile/Custom-field.svg')}
                    alt='img'
                  />
                  <Select
                    isSearchable={false}
                    isLoading={customFieldLoading}
                    value={{ value: '', label: 'Custom Field' }}
                    onChange={(e: any) => {
                      handleChange(e)
                    }}
                    options={[...data]}
                    name='message'
                    className={`common-select`}
                    placeholder='Custom Field'
                    noOptionsMessage={() => customFieldLoading ? 'Loading...' : 'No options'}
                  />
                </div>
              </div>
              {isDefaultRegion && showSelect?.includes('template') && (
                <div className='border-right-1 message-col'>
                  <div className='selectbox' data-testid='ddTemplates'>
                    <img
                      className='imgpos'
                      src={toAbsoluteUrl('/media/mobile/web-link.svg')}
                      alt='img'
                    />
                    <Select
                      isSearchable={false}
                      value={{ value: '', label: 'Template' }}
                      onChange={(e: any) => {
                        handleTemplate(e)
                      }}
                      options={[...Templates]}
                      name='message'
                      className={`common-select`}
                      placeholder='Templates'
                    />
                  </div>
                </div>
              )}
              {showSelect?.includes('weblink') && (
                <div className='border-right-1 message-col'>
                  <div className='selectbox' data-testid='ddShortUrl'>
                    <img
                      className='imgpos'
                      src={toAbsoluteUrl('/media/mobile/web-link.svg')}
                      alt='img'
                    />
                    <Select
                      isSearchable={false}
                      value={{ value: '', label: 'Short URL' }}
                      onChange={(e: any) => {
                        handleWeblinkData(e)
                      }}
                      options={[...options.webLink, ...shortLinkOptions]}
                      name='message'
                      className={`common-select `}
                      placeholder='Short URL'
                    />
                  </div>
                </div>
              )}

              {isDefaultRegion && showSelect?.includes('landingPage') && (
                <div className='border-right-1 message-col'>
                  <div className='selectbox selectname' data-testid='ddLandingPage'>
                    <img
                      className='imgpos'
                      src={toAbsoluteUrl('/media/mobile/Landing-page.svg')}
                      alt='img'
                    />
                    <Select
                      isSearchable={false}
                      onChange={(e: any) => {
                        handleChangeLandingPage(e)
                      }}
                      value={{ value: '', label: 'Landing page' }}
                      options={[...LandingPages]}
                      name='message'
                      className={`common-select `}
                      placeholder='Custom-LandingPage'
                    />
                  </div>
                </div>
              )}
              {isDefaultRegion && showSelect?.includes('review-template') && (ReviewTemplates?.length > 0) && (
                <div className='border-right-1 message-col'>
                  <div className='selectbox' data-testid='rTemplates'>
                    <img
                      className='imgpos'
                      src={toAbsoluteUrl('/media/icons/duotune/general/gen029.svg')}
                      alt='img'
                    />
                    <Select
                      isSearchable={false}
                      value={{ value: '', label: 'Review Request' }}
                      onChange={(e: any) => {
                        handleTemplate(e)
                      }}
                      options={[...ReviewTemplates]}
                      name='message'
                      className={`common-select`}
                      placeholder='Review Request'
                    />
                  </div>
                </div>
              )}
              <div className='d-flex align-items-center border-right-1 justify-content-end last-col message-col'>
                <InsertEmoticonIcon onClick={() => setShowPicker((val) => !val)} />
              </div>
              {showPicker && (
                <div ref={pickerRef}>
                  <EmojiPicker onEmojiClick={onEmojiClick} />
                </div>
              )}
            </div>

            <InputMessageContent
              isMessageSecond={false}
              ref={inputRef}
              disableTextfield={disableTextfield}
              maxLength={quickSms !== true ? 1000 : 1224 - (replyStopToOptOutCount + optoutCount)}
              onChange={handleChange}
              value={userMessage?.message}
              userMessage={userMessage}
              customOptOutList={CustomOptOutList}
              onChangeOptOut={handleOptout}
              showSelect={showSelect}
              isMobile={isMobile}
            />

            <div
              className='border border-1 rounded-1'
              style={{ padding: '8px 12px', marginTop: '8px' }}
            >
              {isRMSChat ? (
                <span>Rich Messaging</span>
              ) : (
                <div className='d-flex justify-content-between align-items-center'>
                  <label
                    style={{
                      color: '#5E6278',
                      fontWeight: 400,
                      fontSize: '12px',
                      letterSpacing: '0%',
                    }}
                  >
                    {quickSms !== true
                      ? `1 MMS Credit${countWords(textMessage) > 1 ? 's' : ''} ${countWords(textMessage) + extraMessageCount }/1000`
                      : `${messageCount?.maxdata - messageCount?.length} / ${messageCount?.maxdata
                      } total character${messageCount?.length > 1 ? 's' : ''} used`}
                  </label>
                  {quickSms === true && (
                    <div style={{ gap: '16px' }}>
                      <label
                        className='text-danger'
                        style={{
                          fontWeight: 600,
                          fontSize: '12px',
                          lineHeight: '14.4px',
                          letterSpacing: '0%',
                          textAlign: 'right',
                        }}
                      >
                        {messageCount?.length} character
                        remaining
                      </label>
                      <label
                        className='bg-primary px-2 py-1 text-white'
                        style={{
                          marginLeft: '16px',
                          border: messageCount?.type == 'Unicode' && enableUnicodeModal ? '2px solid #ff0000' : 'none',
                          cursor: messageCount?.type === 'Unicode' && enableUnicodeModal ? 'pointer' : 'default'
                        }}
                        onClick={messageCount?.type === 'Unicode' && enableUnicodeModal? () => setShowUnicodeModal(true) : undefined}
                      >
                        <b>
                          {' '}
                          {messageCount?.type} {' '} ({messageCount?.credit} SMS Parts)
                        </b>
                      </label>
                      {messageCount?.type === 'Unicode' && enableUnicodeModal && (
                          <i 
                            className='fas fa-exclamation-circle text-warning ms-2'
                            data-bs-toggle='tooltip'
                            data-bs-placement='top'
                            title='Click to view unicode characters'
                            style={{ fontSize: '16px', cursor: 'pointer' }}
                            onClick={() => setShowUnicodeModal(true)}
                          ></i>
                      )}
                    </div>
                  )}
                </div>
              )}
            </div>
            {containsEmoji(textMessage) && (
              <span>Special characters and emojis use multiple character spaces per message</span>
            )}
          </div>
        </div>
      </div>
    </>
  )
}

export default MessageBoxV2
